import { BusinessSchema } from '@40seas/entities/businesses';
import { CastToNumber, EnumSchema, Executor, ExecutorSchema, FromSchema, PolicyType } from '@40seas/entities/common';
import { Currency, Segment, SegmentEntity, WithSegmentBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CreditLineRequestCancelReason } from './credit-line-request-cancel.reason';
import { CreditLineRequestFundingType } from './credit-line-request.funding-type.enum';
import { CreditLineRequestStatus } from './credit-line-request.status.enum';
import { CreditLineRequestType } from './credit-line-request.type';

export const CreditLineRequestSchema = WithSegmentBaseEntitySchema(
    z.object({
        buyer: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .or(BusinessSchema),
        requestedAmount: CastToNumber(z.number()).optional(),
        currency: EnumSchema(Currency),
        status: EnumSchema(CreditLineRequestStatus),
        decisionType: EnumSchema(PolicyType).optional(),
        updatedBy: ExecutorSchema.optional(),
        creditLimit: z.number().nullish(),
        decisionNote: z.string().nullish(),
        cancelReason: EnumSchema(CreditLineRequestCancelReason).nullish(),
        funding: EnumSchema(CreditLineRequestFundingType).optional(),
        type: EnumSchema(CreditLineRequestType).nullish(),
    }),
).strict();

export class CreditLineRequest extends FromSchema(CreditLineRequestSchema) implements SegmentEntity {
    id: string;
    buyer: string;
    requestedAmount?: number;
    currency: Currency;
    status: CreditLineRequestStatus;
    creditLimit?: number;
    cancelReason?: CreditLineRequestCancelReason;
    decisionType?: PolicyType;
    decisionNote?: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    updatedBy?: Executor;
    funding?: CreditLineRequestFundingType;
    type?: CreditLineRequestType;
    segments?: Segment[];
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
